import { Plugin, registerPlugin } from '@capacitor/core';

export interface LpaPlugin extends Plugin {
  isOSCompatible(): Promise<{ isCompatible: boolean }>;
  initLpa(): Promise<{
    lpaEnabled: boolean;
    lpaManagerStatus?: 'Enabled' | 'Not enabled' | 'Not detected';
    'euiccInfo.osVersion'?: string;
  }>;
  getSimInfo(): Promise<{
    subscriptions?: {
      displayName?: string;
      phoneNumber?: string | undefined;
      iccid?: string | undefined;
      subscriptionId: number;
      isEmbedded: boolean;
      canManageSubscription: boolean;
      isActive: boolean;
    }[];
  }>;
  downloadESIM(options: {
    activationCode?: string;
    smdpPlusAddress?: string;
  }): Promise<{
    activationCode?: string | undefined;
    smdpPlusAddress?: string | undefined;
    lpaEnabled?: boolean;
    confirmationCode?: string | undefined;
  }>;
}

const LpaPlugin = registerPlugin<LpaPlugin>('LpaPlugin');

export default LpaPlugin;
